<template>
  <Teleport to="body">
    <transition name="dropdown">
      <ul
        class="dropdown"
        :class="{ 'dropdown--upward': isUpward }"
        v-if="modelValue && (items.length || $slots.header)"
        :style="dropdownStyle"
      >
        <slot name="header" />
        <li
          v-for="item in items"
          :key="item.value"
          :class="optionClass(item)"
          v-tooltip="item.disabled ? item.disabledReason : null"
          @click="handleClick(item, $event)"
        >
          {{ output(item) }}
        </li>
      </ul>
      <ul class="dropdown" v-else-if="modelValue && !items.length && !$slots.header" :style="dropdownStyle">
        Элементов нет или они не найдены
      </ul>
    </transition>
  </Teleport>
</template>

<script setup>
import { ref, watch, onMounted, onBeforeUnmount } from 'vue'

const props = defineProps({
  parent: { type: HTMLElement, default: null },
  items: { type: Array, default: () => [] },
  selectedItem: { type: Object, default: null },
  output: { type: Function, default: (item) => item.text },
  modelValue: { type: Boolean, default: false },
})

const emit = defineEmits(['select', 'update:modelValue'])

const isUpward = ref(false)
const dropdownStyle = ref({})

watch(() => props.modelValue, (val) => {
  if (!val) return
  updatePosition()
})

const optionClass = (item) => ({
  'dropdown__item': true,
  'dropdown__item--selected': props.selectedItem && props.selectedItem.value == item.value,
  'dropdown__item--disabled': item.disabled,
})

const updatePosition = () => {
  if (!props.parent) return
  const rect = props.parent.getBoundingClientRect()
  const viewportHeight = window.innerHeight
  const dropdownHeight = 200

  const spaceBelow = viewportHeight - rect.bottom
  isUpward.value = spaceBelow < dropdownHeight && rect.top > dropdownHeight

  dropdownStyle.value = {
    position: 'fixed',
    left: `${rect.left}px`,
    width: `${rect.width}px`,
    ...(isUpward.value
      ? { bottom: `${viewportHeight - rect.top + 4}px`, top: 'auto' }
      : { top: `${rect.bottom}px`, bottom: 'auto' }
    ),
  }
}

const onSelect = (item) => emit('select', item)

const onClose = (event, forcedClose = false) => {
  if (!props.parent?.contains(event.target) || forcedClose) emit('update:modelValue', false)
}

const handleClick = (item, event) => {
  if (item.disabled) return
  onSelect(item)
  onClose(event, true)
}

onMounted(() => {
  document.addEventListener('click', onClose)
  window.addEventListener('resize', updatePosition)
  window.addEventListener('scroll', updatePosition, true)
})

onBeforeUnmount(() => {
  document.removeEventListener('click', onClose)
  window.removeEventListener('resize', updatePosition)
  window.removeEventListener('scroll', updatePosition, true)
})
</script>